import React, { useState } from 'react';
import { Flex } from '@maxhub/max-ui';

interface ConsentModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConsentModal: React.FC<ConsentModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  const [agreed, setAgreed] = useState(false);

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: 16,
    }}>
      <div style={{
        backgroundColor: '#fff',
        padding: 24,
        borderRadius: 12,
        maxWidth: 500,
        width: '100%',
        maxHeight: '90%',
        overflow: 'auto',
      }}>
        <h2 style={{ margin: '0 0 8px 0', fontSize: 20 }}>📋 Политика конфиденциальности</h2>

        <div style={{ fontSize: 14, lineHeight: 1.6, color: '#333', marginBottom: 16 }}>
          <p style={{ margin: '0 0 12px 0' }}>
            Перед записью на мероприятие, пожалуйста, ознакомьтесь с нашей политикой конфиденциальности.
          </p>
          <hr style={{ margin: '12px 0' }} />

          <h4 style={{ margin: '8px 0', fontSize: 14 }}>1. Какие данные мы собираем</h4>
          <ul style={{ margin: '4px 0 12px 0', paddingLeft: 20 }}>
            <li>Имя и фамилия пользователя</li>
            <li>Идентификатор пользователя в мессенджере MAX (user_id)</li>
            <li>Идентификатор чата для отправки уведомлений (chat_id)</li>
            <li>Информация о записях на мероприятия</li>
          </ul>

          <h4 style={{ margin: '8px 0', fontSize: 14 }}>2. Как мы используем ваши данные</h4>
          <ul style={{ margin: '4px 0 12px 0', paddingLeft: 20 }}>
            <li>Идентификация пользователя при записи на мероприятия</li>
            <li>Отправка уведомлений о записях, изменениях и отменах</li>
            <li>Напоминания о предстоящих мероприятиях</li>
            <li>Взаимодействие с администратором сервиса</li>
          </ul>

          <h4 style={{ margin: '8px 0', fontSize: 14 }}>3. Ваши права</h4>
          <ul style={{ margin: '4px 0 12px 0', paddingLeft: 20 }}>
            <li>Отозвать согласие на обработку персональных данных в любой момент</li>
            <li>Запросить копию своих данных</li>
            <li>Требовать исправления неточных данных</li>
            <li>Требовать удаления данных (за исключением случаев, когда хранение требуется по закону)</li>
          </ul>

          <p style={{ fontSize: 12, color: '#666', marginTop: 12 }}>
            Данные хранятся в зашифрованном виде на защищённых серверах и не передаются третьим лицам.
            По всем вопросам: <a href="mailto:info@asoloveva.ru" style={{ color: '#007AFF' }}>info@asoloveva.ru</a>
          </p>
        </div>

        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 16, cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            style={{ marginTop: 2 }}
          />
          <span style={{ fontSize: 14 }}>
            Я ознакомлен(а) и согласен(на) с политикой конфиденциальности
          </span>
        </label>

        <Flex gap={8} style={{ justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '8px 16px',
              cursor: 'pointer',
              backgroundColor: '#f0f0f0',
              border: 'none',
              borderRadius: 6,
              fontSize: 14,
            }}
          >
            Отмена
          </button>
          <button
            onClick={onConfirm}
            disabled={!agreed}
            style={{
              padding: '8px 16px',
              cursor: agreed ? 'pointer' : 'not-allowed',
              backgroundColor: agreed ? '#007AFF' : '#ccc',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              fontSize: 14,
              opacity: agreed ? 1 : 0.6,
            }}
          >
            ✅ Подтверждаю запись
          </button>
        </Flex>
      </div>
    </div>
  );
};